module.exports = __webpack_public_path__ + "img/book.0a5a19c9.svg";